"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.CoordinateView = function (_a) {
    var board = _a.board, position = _a.position, props = __rest(_a, ["board", "position"]);
    var coordinate = position.toCoordinate();
    var rowCoordinate = position.rotate(board.rotated).y === board.rows - 1 ? coordinate.charAt(0) : "";
    var columnCoordinate = position.rotate(board.rotated).x === 0 ? coordinate.charAt(1) : "";
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("span", __assign({ className: "chess-board-coordinate chess-board-coordinate--row" }, props), rowCoordinate),
        react_1.default.createElement("span", __assign({ className: "chess-board-coordinate chess-board-coordinate--column" }, props), columnCoordinate)));
};
exports.default = exports.CoordinateView;
